import React from 'react';
import { LinkedinIcon, TwitterIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#151314] pt-20 pb-10 border-t-4 border-brand-primary relative overflow-hidden" data-id="element-83">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-brand-primary/5 blur-[150px] pointer-events-none" data-id="element-84"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-85">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-86">
          {/* Col 1: Brand */}
          <div className="space-y-6" data-id="element-87">
            <div data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/78heWmZdxPSksJ4ucoHqqb/Spring_Link.png" alt="SpringLinks Solutions Ltd" className="h-10 w-auto brightness-0 invert" data-id="element-89" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-90">
              Kenya's AI-first enterprise solutions company. Certified partner
              of SentientLogics AI powered by Prisma AI.
            </p>
            <div className="flex gap-4" data-id="element-91">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-brand-primary hover:text-white transition-all duration-300" data-id="element-92">
                <LinkedinIcon className="w-5 h-5" data-id="element-93" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-brand-primary hover:text-white transition-all duration-300" data-id="element-94">
                <TwitterIcon className="w-5 h-5" data-id="element-95" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-brand-primary hover:text-white transition-all duration-300" data-id="element-96">
                <FacebookIcon className="w-5 h-5" data-id="element-97" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-brand-primary hover:text-white transition-all duration-300" data-id="element-98">
                <InstagramIcon className="w-5 h-5" data-id="element-99" />
              </a>
            </div>
          </div>

          {/* Col 2: Solutions */}
          <div data-id="element-100">
            <h4 className="text-white font-bold mb-6" data-id="element-101">Solutions</h4>
            <ul className="space-y-3" data-id="element-102">
              {['Generative AI', 'Intelligent Automation', 'Custom AI Development', 'AI Consulting', 'Data Analytics', 'AI Integration'].map(item => <li key={item} data-id="element-103">
                  <a href="#" className="text-gray-400 hover:text-brand-primary transition-colors text-sm" data-id="element-104">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Company */}
          <div data-id="element-105">
            <h4 className="text-white font-bold mb-6" data-id="element-106">Company</h4>
            <ul className="space-y-3" data-id="element-107">
              {['About Us', 'Case Studies', 'Blog', 'Careers', 'Contact'].map(item => <li key={item} data-id="element-108">
                    <a href="#" className="text-gray-400 hover:text-brand-primary transition-colors text-sm" data-id="element-109">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div data-id="element-110">
            <h4 className="text-white font-bold mb-6" data-id="element-111">Contact</h4>
            <ul className="space-y-4" data-id="element-112">
              <li data-id="element-113">
                <a href="mailto:info@springlinks.co.ke" className="text-gray-400 hover:text-brand-primary transition-colors text-sm flex flex-col" data-id="element-114">
                  <span className="text-white/50 text-xs mb-1 uppercase tracking-wider" data-id="element-115">
                    Email
                  </span>
                  info@springlinks.co.ke
                </a>
              </li>
              <li data-id="element-116">
                <a href="tel:+254724570060" className="text-gray-400 hover:text-brand-primary transition-colors text-sm flex flex-col" data-id="element-117">
                  <span className="text-white/50 text-xs mb-1 uppercase tracking-wider" data-id="element-118">
                    Phone
                  </span>
                  +254 724 570 060
                </a>
              </li>
              <li data-id="element-119">
                <div className="text-gray-400 text-sm flex flex-col" data-id="element-120">
                  <span className="text-white/50 text-xs mb-1 uppercase tracking-wider" data-id="element-121">
                    Location
                  </span>
                  Nairobi, Kenya
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-122">
          <p className="text-gray-500 text-sm" data-id="element-123">
            © 2026 SpringLinks Solutions Ltd. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-124">
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-125">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-126">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}